import { Trans, useTranslation } from 'react-i18next';

import { AdProductsReviewNotEnoughCreativesInfoTranslationKey } from '@features/campaigns/shared/config/adProductsCountryConfig.ts';
import { InfoPanel } from '@shared/components/InfoPanel/InfoPanel.tsx';
import { InfoPanelTypes } from '@shared/components/InfoPanel/InfoPanel.types.ts';
import { LinkText } from '@shared/components/LinkText/LinkText.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';
import { routePaths } from '@shared/router/routePaths.ts';
import { CampaignId } from '@shared/types/campaign.ts';

interface CreativesUploadReminderProps {
  campaignId?: CampaignId;
  notEnoughCreativesInfoTranslationKey: AdProductsReviewNotEnoughCreativesInfoTranslationKey;
}

export function CreativesUploadReminder({
  campaignId,
  notEnoughCreativesInfoTranslationKey,
}: CreativesUploadReminderProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const redirectUrl = routePaths.campaignBuilderStep03.url(campaignId);

  return (
    <div className='row'>
      <div className={'col-12'}>
        <InfoPanel type={InfoPanelTypes.INFO} headerText={t('builder.steps.step05.notEnoughCreativesInfo.header')}>
          <p>
            <Trans
              t={t}
              i18nKey={notEnoughCreativesInfoTranslationKey}
              components={[<LinkText key={0} externalLink={false} target='_self' to={redirectUrl} />]}
            />
          </p>
        </InfoPanel>
      </div>
    </div>
  );
}
